"use client";

import { ThemeProvider } from "next-themes";
import { Provider as ReduxProvider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "@lib/store/store";
import { useEffect, useState } from "react";
import { I18nextProvider } from "react-i18next";
import i18n from "@/lib/i18n/i18n";
import "@/lib/i18n/i18n";
import { DevModeActivator } from "@components/developer/DevModeActivator";

const ThemeAndLanguageInitializer = ({ children }: { children: React.ReactNode }) => {
  const userSettings = store.getState().user?.settings;
  const [initialized, setInitialized] = useState(false);

  // Initialize language from Redux store
  useEffect(() => {
    if (userSettings?.lang && !initialized) {
      i18n.changeLanguage(userSettings.lang);
      setInitialized(true);
    }
  }, [userSettings?.lang, initialized]);

  return children;
};

export function Providers({ children }: { children: React.ReactNode }) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  // This ensures we don't render until client-side to avoid hydration issues
  if (!mounted) {
    return null;
  }

  return (
    <ReduxProvider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <I18nextProvider i18n={i18n}>
          <ThemeProvider
            attribute="class"
            defaultTheme={"light"}
            enableSystem={false}
            disableTransitionOnChange
          >
            <ThemeAndLanguageInitializer>
              <DevModeActivator>
                {children}
              </DevModeActivator>
            </ThemeAndLanguageInitializer>
          </ThemeProvider>
        </I18nextProvider>
      </PersistGate>
    </ReduxProvider>
  );
}